import React, {Component} from 'react'

import Screen from './ui/Screen'

import withStyles from '@material-ui/core/styles/withStyles'

class AwaitRegistrationScreen extends Component {

	render() {
		return <Screen>
			Ваша учетная запись ожидает подтверждения администратором.
		</Screen>
	}

}

export default withStyles(theme => ({

}))(AwaitRegistrationScreen)
